import React, { useState } from "react";
import EmptyImg from "../../Dashboard/assets/img/create-project.png";
import DashboardLeftMenu from "../DashboardLeftMenu";
import DashboardHeader from "../../Header/DashboardHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faEye } from "@fortawesome/free-solid-svg-icons";
import "react-datepicker/dist/react-datepicker.css";
import ReactDatePicker from "react-datepicker";
import { NODE_HOST_URL_v1, VerificationDetail } from "../api/Api";
import Axios from "../../../axios/Axios";
import { handleUserLog } from "../../Utils/Utils";

const EmailVerification = () => {
    const lStorage = JSON.parse(localStorage.getItem("login"));
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const date = new Date();

    const [error, setError] = useState({
        errorStatus: false,
        errorMessage: "",
        bgColor: "",
    });
    const [startDate, setStartDate] = useState(date);
    const [endDate, setEndDate] = useState(date);
    const [urlDataReport, setUrlDataReport] = useState([]);
    const [disable, setDisable] = useState(false);

    const addDays = (date, days) => {
        const newDate = new Date(date);
        newDate.setDate(date.getDate() + days);
        return newDate;
    };

    const currentDate = (currentDate) => {
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, "0");
        const day = String(currentDate.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const urlDetails = async () => {
        // ✅ Use VerificationSummary as in Postman
        const payload = {
            user_id: userId,
            token: userToken,
            method: "VerificationSummary",
            fromdate: currentDate(startDate),
            todate: currentDate(endDate),
        };

        try {
            setDisable(true);

            console.log('Payload sent:', payload); // Debug log to see what we're sending

            // ✅ Call VerificationDetail() function with payload
            const { data } = await VerificationDetail(payload);

            console.log('API Response:', data); // Debug log to see the structure

            if (data.success) {
                let reportData = [];

                // Check if data has a 'data' property (array format)
                if (data.data) {
                    reportData = Array.isArray(data.data) ? data.data : [data.data];
                    reportData = reportData.filter(item => item && typeof item === 'object');
                }
                // If no 'data' property, the response itself contains the counts
                else if (data.total_approve !== undefined || data.total_reject !== undefined || data.total_record !== undefined) {
                    reportData = [{
                        _id: userId,
                        user_id: userId,
                        total_approve: data.total_approve || 0,
                        total_reject: data.total_reject || 0,
                        total_record: data.total_record || (data.total_approve || 0) + (data.total_reject || 0)
                    }];
                }

                setUrlDataReport(reportData);
                handleUserLog("", "search_button", "email", "User Click on Search Button in email verification summary", "email_verification", "", { from_date: currentDate(startDate), to_date: currentDate(endDate) });
            } else {
                setError({
                    errorStatus: true,
                    errorMessage: data.message || "Failed to fetch data",
                    bgColor: "alert alert-danger",
                });
                setTimeout(() => {
                    setError({ errorStatus: false });
                }, 2000);
                handleUserLog("", "search_button", "email", data.message || "Failed to fetch data", "email_verification", "", { from_date: currentDate(startDate), to_date: currentDate(endDate) });
            }
        } catch (error) {
            console.error("Error fetching verification summary:", error);
            setError({
                errorStatus: true,
                errorMessage: "Something went wrong. Please try again later.",
                bgColor: "alert alert-danger",
            });
            setTimeout(() => {
                setError({ errorStatus: false });
            }, 3000);
            handleUserLog("", "search_button", "email", "Something went wrong. Please try again later.", "email_verification", "", { from_date: currentDate(startDate), to_date: currentDate(endDate) });
        } finally {
            setDisable(false);
        }
    };

    const sendData = (filterType) => {
        handleUserLog("", "view_button", "email_verification", `User click on view button for ${filterType} records`, "email_verification", "", { filter_type: filterType });
        const url = `/dashboard/email-verification-report/${filterType}/${currentDate(
            startDate
        )}/${currentDate(endDate)}`;
        window.open(url, "_blank");
    };
    // ✅ For Approved Download
    const handleDownloadApproved = async () => {
        try {
            const payload = {
                user_id: userId,
                method: "DownloadApproved",
                fromdate: currentDate(startDate),
                todate: currentDate(endDate),
            };

            const response = await Axios.post(
                `${NODE_HOST_URL_v1}/EmailVerification`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                    },
                    responseType: "blob", // 👈 important
                }
            );

            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `Approved_Report_${currentDate(startDate)}_to_${currentDate(endDate)}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            handleUserLog("", "download_approved_email_summary", "email", "User downloaded approved report", "email_verification", "", { from_date: currentDate(startDate), to_date: currentDate(endDate) });
        } catch (error) {
            console.error("Download Approved failed:", error);
            alert("Failed to download approved report.");
            handleUserLog("", "download_approved_email_summary", "email", "Failed to download approved report.", "email_verification", "", { from_date: currentDate(startDate), to_date: currentDate(endDate) });
        }
    };

    // ✅ For Rejected Download
    const handleDownloadRejected = async () => {
        try {
            const payload = {
                user_id: userId,
                method: "DownloadReject",
                fromdate: currentDate(startDate),
                todate: currentDate(endDate),
            };

            const response = await Axios.post(
                `${NODE_HOST_URL_v1}/EmailVerification`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                    },
                    responseType: "blob",
                }
            );

            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `Rejected_Report_${currentDate(startDate)}_to_${currentDate(endDate)}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            handleUserLog("", "download_rejected_email_summary", "email", "User downloaded rejected report", "email_verification", "", { from_date: currentDate(startDate), to_date: currentDate(endDate) });
        } catch (error) {
            console.error("Download Rejected failed:", error);
            alert("Failed to download rejected report.");
            handleUserLog("", "download_rejected_email_summary", "email", "Failed to download rejected report.", "email_verification", "", { from_date: currentDate(startDate), to_date: currentDate(endDate) });
        }
    }
    // ✅ For All Download (Approved + Rejected)
    const handleDownloadAll = async () => {
        try {
            const payload = {
                user_id: userId,
                method: "DownloadReport",
                fromdate: currentDate(startDate),
                todate: currentDate(endDate),
            };

            const response = await Axios.post(
                `${NODE_HOST_URL_v1}/EmailVerification`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                    },
                    responseType: "blob",
                }
            );

            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `All_Email_Verification_Report_${currentDate(startDate)}_to_${currentDate(endDate)}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            handleUserLog("", "download_all_email_report", "email", "User downloaded all report", "email_verification", "", { from_date: currentDate(startDate), to_date: currentDate(endDate) });
        } catch (error) {
            console.error("Download All Report failed:", error);
            alert("Failed to download all report.");
            handleUserLog("", "download_all_email_report", "email", "Failed to download all report.", "email_verification", "", { from_date: currentDate(startDate), to_date: currentDate(endDate) });
        }
    };




    return (
        <div className="wrapper">
            <DashboardLeftMenu />
            <div className="main">
                <DashboardHeader />
                <main className="content">
                    <div className="card">
                        <div className="card-body">
                            <div className="container-fluid p-0">
                                <div className="row">
                                    <div className="col-md-12">
                                        {error.errorStatus && (
                                            <div className={error.bgColor} role="alert">
                                                <button
                                                    type="button"
                                                    className="close"
                                                    data-dismiss="alert"
                                                    aria-label="Close"
                                                >
                                                    <span aria-hidden="true">×</span>
                                                </button>
                                                <div>{error.errorMessage}</div>
                                            </div>
                                        )}
                                        <h5 className="card-title">Email Verification Summary</h5>

                                        {/*  Date pickers and search button in one row */}
                                        <form
                                            className="form-row align-items-end"
                                            id="EntityFormidFrom"
                                        >
                                            <div className="mb-3 col-12 col-md-4">
                                                <label className="ml-4 d-block">From Date</label>
                                                <ReactDatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    selected={startDate}
                                                    className="form-control ms-2 ml-4"
                                                    onChange={(date) => setStartDate(date)}
                                                    selectsStart
                                                    startDate={startDate}
                                                />
                                            </div>

                                            <div className="mb-3 col-12 col-md-4">
                                                <label className="ml-4 d-block">To Date</label>
                                                <ReactDatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    className="form-control ms-2 ml-4"
                                                    selected={endDate}
                                                    onChange={(date) => setEndDate(date)}
                                                    selectsEnd
                                                    startDate={startDate}
                                                    minDate={startDate}
                                                    maxDate={addDays(startDate, 30)}
                                                />
                                            </div>

                                            <div className="mb-3 col-12 col-md-4 d-flex justify-content-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-success mt-4"
                                                    onClick={urlDetails}
                                                    disabled={disable}
                                                >
                                                    Search
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                                <div className="p-2">
                                    <div className="flex-fill">
                                        {urlDataReport.length > 0 ? (
                                            <>
                                                {/* Total Email Sent Display - Top Left */}
                                                <div className="mb-3" style={{ 
                                                    display: "inline-block",
                                                    backgroundColor: "#f8f9fa", 
                                                    border: "1px solid #e9ecef",
                                                    borderRadius: "6px", 
                                                    padding: "8px 12px",
                                                    fontSize: "14px",
                                                    color: "#495057"
                                                }}>
                                                    <span style={{ fontWeight: "500" }}>Total Email Sent: </span>
                                                    <span style={{ fontWeight: "600", color: "#007bff" }}>
                                                        {urlDataReport[0]?.total_record || 0}
                                                    </span>
                                                </div>

                                                <div className="table-responsive">
                                                    <table className="table table-striped table-sm">
                                                        <thead>
                                                            <tr>
                                                                <th>Status</th>
                                                                <th>Count</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {urlDataReport.map((item, i) => (
                                                                <React.Fragment key={i}>
                                                                    {/* Row for Total Approved */}
                                                                    <tr>
                                                                        <td>Approved</td>
                                                                        <td>{item?.total_approve || 0}</td>
                                                                        <td>
                                                                            <span
                                                                                onClick={handleDownloadApproved}
                                                                                className="badge bg-primary mr-1"
                                                                                style={{ cursor: "pointer" }}
                                                                            >
                                                                                <FontAwesomeIcon icon={faDownload} />
                                                                            </span>

                                                                            {/* 👇 Call sendData('approve') */}
                                                                            <span
                                                                                onClick={() => sendData("approve")}
                                                                                className="badge bg-info"
                                                                                style={{ cursor: "pointer" }}
                                                                            >
                                                                                <FontAwesomeIcon icon={faEye} />
                                                                            </span>
                                                                        </td>
                                                                    </tr>

                                                                    {/* Row for Total Rejected */}
                                                                    <tr>
                                                                        <td>Rejected</td>
                                                                        <td>{item?.total_reject || 0}</td>
                                                                        <td>
                                                                            <span
                                                                                onClick={handleDownloadRejected}
                                                                                className="badge bg-primary mr-1"
                                                                                style={{ cursor: "pointer" }}
                                                                            >
                                                                                <FontAwesomeIcon icon={faDownload} />
                                                                            </span>
                                                                            {/* 👇 Call sendData('reject') */}
                                                                            <span
                                                                                onClick={() => sendData("reject")}
                                                                                className="badge bg-danger"
                                                                                style={{ cursor: "pointer" }}
                                                                            >
                                                                                <FontAwesomeIcon icon={faEye} />
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                </React.Fragment>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </>
                                        

                                        ) : (
                                            <div className="text-center">
                                                <div className="card-body">
                                                    <img
                                                        alt="Empty Data"
                                                        className="project-empty-img"
                                                        src={EmptyImg}
                                                    />
                                                    <p>Data Not Found</p>
                                                </div>
                                            </div>
                                        )}

                                        {/* View All Button and Download All Button - Bottom Right */}
                                        {urlDataReport.length > 0 && (
                                            <div className="d-flex justify-content-end mt-3">
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-success"
                                                    onClick={handleDownloadAll}
                                                    style={{
                                                        borderRadius: "20px",
                                                        padding: "8px 20px",
                                                        fontWeight: "500",
                                                        marginRight: "10px"
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faDownload} className="mr-1" />
                                                    Download All Report
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-primary"
                                                    onClick={() => sendData("all")}
                                                    style={{
                                                        borderRadius: "20px",
                                                        padding: "8px 20px",
                                                        fontWeight: "500"
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faEye} className="mr-1" />
                                                    View All Records
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main >
            </div >
        </div >
    );
};

export default EmailVerification;
